/**
 * 권한에 따라 달라지는 layout header 의 메뉴와 버튼 아이템 정의
 */
/* DATA FORMAT
const NAME = {
  title: [이름],
  link: [라우터 경로],
  menuClass: [아이템이 헤더 메뉴로 사용되는 경우의 클래스],
  dropClass: [아이템이 드롭 메뉴로 사용되는 경우의 클래스],
  sub:[
    {
      title: [이름],
      link: [라우터 경로],
      dropClass: [아이템이 드롭 메뉴로 사용되는 경우의 클래스],
      topClass: [아이템이 탑 메뉴로 사용되는 경우의 클래스]
    }
  ]
} 
*/

////////////////////////////////////////////////////
// 메뉴 아이템 정의
////////////////////////////////////////////////////

// Add new 제품/서비스 관리
// const MENU_REPLY = {
//   id: 10,
//   title: "제품/서비스 관리",
//   link: "/reply",
//   sub: [
//     { title: "제품 관리", link: "/reply" },
//     { title: "서비스 관리", link: "/reply" },
//   ],
// };

// 플랫폼 소개
const MENU_PLATFORM = {
  id: 1,
  title: "플랫폼 소개",
  link: "/newAgingPlatform",
  sub: [
    { title: "플랫폼 소개", link: "", forTopMenu: true },
    { title: "AgeTech Platform", link: "/newAgingPlatform" },
    { title: "시니어산업 글로벌트렌드", link: "/globalTrend" }, // 기존 이름 '고령친화산업 글로벌트렌드 => '시니어산업 클로벌 트렌드'로 변경
  ],
};

// 서비스 소개
const MENU_SERVICE = {
  id: 2,
  title: "서비스 소개",
  link: "/corpNetworking",
  sub: [
    { title: "서비스소개", link: "", forTopMenu: true },
    { title: "고령 소비자", link: "/olderConsumers" },
    { title: "AgeTech와 산업사회", link: "/newagingcenter" },   //기존 이름 '교육·정보 제공' => 'AgeTech와 산업사회' 로  변경
    { title: "시니어산업 네트워킹", link: "/corpNetworking" },        //기존 이름 '고령친화산업네트워킹 네트워킹' => '시니어산업 네트워킹' 로  변경
  ],
};

// 고령소비자 서비스
const MENU_CUSTOMER = {
  title: "고령 소비자 서비스",
  link: "/serviceSearch",
  sub: [
    { title: "고령 소비자 서비스", link: "", forTopMenu: true },
    { title: "제품 및 서비스 검색", link: "/serviceSearch" },
  ],
};

// 커뮤니티
const COMMUNITY_TITLE = "커뮤니티";
const COMMUNITY_LINK = "/notice";

const MENU_COMMUNITY = {
  title: COMMUNITY_TITLE,
  link: COMMUNITY_LINK,
  sub: [
    { title: COMMUNITY_TITLE, link: "", forTopMenu: true },
    { title: "공지사항", link: "/notice" },
    { title: "FAQ", link: "/FAQ" },
    { title: "1:1문의", link: "/QnA" },
  ],
};

// 고령친화산업혁신센터         => '고령친화 실증센터' 로 명칭 변경
const MENU_CENTER = {
  title: "AgeTech 실증센터",
  link: "/centerInfo",
  sub: [
    { title: "AgeTech 실증센터", link: "", forTopMenu: true },
    { title: "센터소개", link: "/centerInfo" },
    { title: "센터사업안내", link: "/centerIntro" },
  ],
};

//Age-Tech-Service 교육영상 (user)      'AgeTech산업사회 기여를 위한 교육영상(구)'    'AgeTech와 산업사회' 로 명칭 변경
const MENU_AgeTechService = {
  title: "AgeTech와 산업사회",
  link: "/ageTechService",
  sub: [
    { title: "AgeTech와 산업사회", link: "", forTopMenu: true },
    { title: "AgeTech와 산업사회", link: "/ageTechService"},
  ],
};



// 기술수용 코호트    Newaging&technology DATA  =>  AgeTech DATA  로 명칭 변경
const COHORT_TITLE = "AgeTech DATA";   
const COHORT_LINK = "/survey";
const SUB_COHORT = { title: COHORT_TITLE, link: "", forTopMenu: true };
const SUB_COHORT_CUSTOMER = { title: "고령소비자 관련 정보", link: "/atWork" };
const SUB_COHORT_SURVEY = { title: "설문 리스트", link: "/survey" };
const SUB_COHORT_EQUIPMENT = { title: "장비데이터", link: "/equipmentData" };
const SUB_COHORT_SURVEY_RESULT = {
  title: "설문 결과 데이터",
  link: "/survey-result",
};

const MENU_USER_COHORT = {
  title: COHORT_TITLE,
  link: COHORT_LINK,
  sub: [
    SUB_COHORT,
    SUB_COHORT_CUSTOMER,
    SUB_COHORT_SURVEY,
    SUB_COHORT_SURVEY_RESULT,
    SUB_COHORT_EQUIPMENT,
  ],
};
const MENU_CORP_COHORT = {
  title: COHORT_TITLE,
  link: COHORT_LINK,
  sub: [
    SUB_COHORT,
    SUB_COHORT_SURVEY, {
      title: '설문 결과 데이터',
      link: '/corp/SurveyResultManagement'
    },
    SUB_COHORT_EQUIPMENT,
  ],
};

// 마이페이지 User
const MYPAGE_TITLE = "마이페이지";
const MYPAGE_LINK = "";
const SUN_MYPAGE_TITLE = { title: "마이페이지", link: "", forTopMenu: true };
const SUB_MYPAGE_PROFILE = { title: "프로필 정보", link: "/user" };
const SUB_MYPAGE_SEARCHHISTORY = {
  title: "나의검색이력",
  link: "/user/searchHistory",
};
const SUB_USER_SEARCHNETWROKING = {
  title: "네트워킹 검색",
  link: "/user/searchNetworking",
};

const SUB_USER_MYMATCHING = {
  title: "네트워킹 검색",
  link: "/user/myMatching",
};

const MENU_USER_MYPAGE = {
  title: MYPAGE_TITLE,
  link: MYPAGE_LINK,
  mobileMenu: "mobileBlock",
  sub: [
    SUN_MYPAGE_TITLE,
    SUB_MYPAGE_PROFILE,
    SUB_MYPAGE_SEARCHHISTORY,
    SUB_USER_MYMATCHING,
  ],
};

const SUB_PROFILE_TITLE = { title: "네트워킹", link: "", forTopMenu: true };

const MENU_USER_NETWORKING = {   ///고령친화산업네트워킹 => 시니어산업네트워킹
  title: "시니어산업 네트워킹",
  link: "/user/searchNetworking",
  sub: [SUB_PROFILE_TITLE, SUB_USER_SEARCHNETWROKING],
};

// 마이페이지 corp
const MYPAGE_CORP_TITLE = "마이페이지";
const MYPAGE_CORP_LINK = "";
const SUN_MYPAGE_CORP_TITLE = {
  title: "마이페이지",
  link: "",
  forTopMenu: true,
};
const SUB_MYPAGE_CORP_PROFILE = { title: "프로필 정보", link: "/corp" };
const SUB_CORP_SEARCHNETWORKING = {
  title: "네트워킹 검색",
  link: "/corp/SearchNetworking",
};

const MENU_CORP_NETWORKING = {    //네트워킹 => 고령친화사업네트워킹 명칭변경
  title: "고령친화사업 네트워킹",
  link: "/corp/SearchNetworking",
  sub: [
    { title: "고령친화사업 네트워킹", link: "", forTopMenu: true },
    SUB_CORP_SEARCHNETWORKING,
  ],
};

const SUB_CORP_MYMATCHING = {
  title: "나의 매칭 현황",
  link: "/corp/myMatching",
};

// const SUB_CORP_SURVEY = {
//   title: "설문 결과 데이터",
//   link: "/corp/SurveyResultManagement",
// };

const MENU_CORP_MYPAGE = {
  title: MYPAGE_CORP_TITLE,
  link: MYPAGE_CORP_LINK,
  mobileMenu: "mobileBlock",
  sub: [
    SUN_MYPAGE_CORP_TITLE,
    SUB_MYPAGE_CORP_PROFILE,
    SUB_CORP_MYMATCHING,
  ],
};

// 제품·서비스 관리 corp
const MENU_CORP_PRODUCT_MANAGEMENT = {
  title: "제품·서비스 관리",
  link: "/corp/corpProductManagement",
  AClass: "navyC",
  BClass: "active",
  sub: [
    { title: "제품·서비스 관리", link: "", forTopMenu: true },
    { title: "제품 관리", link: "/corp/corpProductManagement" },
    { title: "서비스 관리", link: "/corp/corpServiceManagement" },
  ],
};

// 대시보드
const MENU_DASHBOARD = {
  title: "대시 보드",
  link: "/admin",
  sub: [
    { title: "대시 보드", link: "", forTopMenu: true },
    { title: "대시 보드", link: "/admin" },
  ],
};

// 회원 관리
const MENU_ACCOUNT_MANAGEMENT = {
  title: "회원 관리",
  link: "/admin/accountManagement",
  sub: [
    { title: "회원 관리", link: "", forTopMenu: true },
    { title: "회원 관리", link: "/admin/accountManagement" },
  ],
};

// 제품·서비스 관리
const MENU_PRODUCT_MANAGEMENT = {
  title: "제품·서비스 관리",
  link: "/admin/productManagement",
  AClass: "navyC",
  BClass: "active",
  sub: [
    { title: "제품·서비스 관리", link: "", forTopMenu: true },
    { title: "제품 관리", link: "/admin/productManagement" },
    { title: "서비스 관리", link: "/admin/serviceManagement" },
  ],
};

// 기술수용 코호트       NewAging&Technology Data => AgeTech DATA 로 명칭 변경 
const MENU_COHORT_MANAGEMENT = {      
  title: "AgeTech DATA",
  link: "/admin/surveyManagement",
  sub: [
    { title: "AgeTech DATA", link: "", forTopMenu: true },
    { title: "설문 관리", link: "/admin/surveyManagement" },
    { title: "데이터 관리", link: "/admin/dataManagement" },
    { title: "설문 결과 데이터", link: "/admin/SurveyResultManagement" },
    SUB_COHORT_EQUIPMENT,
  ],
};

// 커뮤니티 관리
const MENU_COMMUNITY_MANAGEMENT = {
  title: "커뮤니티 관리",
  link: "/admin/noticeManagement",
  sub: [
    { title: "커뮤니티 관리", link: "", forTopMenu: true },
    { title: "공지사항 관리", link: "/notice" },
    /* {title: '공지사항 관리', link: '/admin/noticeManagement'}, */
    { title: "FAQ 관리", link: "/FAQ" },
    { title: "1:1 문의", link: "/QnA" },
  ],
};

// 카테고리 관리
const MENU_CATEGORY_MANAGEMENT = {
  title: "카테고리 관리",
  link: "/admin/categoryManagement",
  sub: [
    { title: "카테고리 관리", link: "", forTopMenu: true },
    { title: "카테고리 관리", link: "/admin/categoryManagement" },
  ],
};

//Age-Tech-Service 교육영상 관리 (admin)      'Age-Tech-Service 교육영상' =>  'AgeTech와 산업사회' 로 명칭 변경
const MENU_ADMIN_AgeTechService = {
  title: "AgeTech와 산업사회",
  link: "/admin/ageTechService",
  sub: [
    { title: "AgeTech와 산업사회", link: "", forTopMenu: true },
    { title: "AgeTech와 산업사회", link: "/admin/ageTechService"},
  ],
};

// 네트워킹 관리
const NETWORKING_TITLE = "네트워킹 관리";
const NETWORKING_LINK = "/manager/networkManagement";
const SUB_NETWORKING = { title: "네트워킹 관리", link: "", forTopMenu: true };
const SUB_NETWORKING_MAPPING = {
  title: "직접매칭 관리",
  link: "/manager/networkManagement",
};
const SUB_NETWORKING_NAPA = {
  title: "NAP자문 관리",
  link: "/manager/nAPAdvisoryManagement",
};
const SUB_NETWORKING_SEARCH = {
  title: "네트워킹 검색",
  link: "/manager/networkSearch",
};

const MENU_NETWORKING_MANAGEMENT = {
  title: NETWORKING_TITLE,
  link: NETWORKING_LINK,
  sub: [
    SUB_NETWORKING,
    SUB_NETWORKING_MAPPING,
    SUB_NETWORKING_NAPA,
    SUB_NETWORKING_SEARCH,
  ],
};


const MENU_ADMIN_NETWORKING_MANAGEMENT = {
  title: "네트워킹 관리",
  link: "/admin/networkManagement",
  sub: [
    { title: "네트워킹 관리", link: "", forTopMenu: true },
    { title: "직접매칭 관리", link: "/admin/networkManagement", },
    { title: "NAP자문 관리", link: "/admin/napAdvisoryManagement" },
    { title: "네트워킹 검색", link: "/admin/networkSearch" },
  ],
};

const MENU_MEMBER_MANAGEMENT = {
  title: "회원관리",
  link: "",
};

////////////////////////////////////////////////////
// 권한 별 메뉴 리스트 정의
////////////////////////////////////////////////////
const COMMON_MENU_ITEMS = [
  MENU_PLATFORM,
  MENU_SERVICE,
  MENU_CUSTOMER,
  MENU_AgeTechService,
  MENU_CENTER,
  MENU_COMMUNITY,
];

const COMMON_FOOTER_MENU_ITEMS = [MENU_PLATFORM, MENU_SERVICE, MENU_COMMUNITY];

const USER_MENU_ITEMS = [
  MENU_PLATFORM,
  MENU_SERVICE,
  MENU_CUSTOMER,
  MENU_AgeTechService,
  MENU_USER_COHORT,
  MENU_USER_NETWORKING,
  //MENU_USER_MYPAGE,
  MENU_CENTER,
  MENU_COMMUNITY,
];

const CORP_MENU_ITEMS = [
  MENU_PLATFORM,
  MENU_SERVICE,
  MENU_CORP_NETWORKING,
  MENU_AgeTechService,
  MENU_CORP_COHORT,
  MENU_CUSTOMER,
  MENU_CORP_PRODUCT_MANAGEMENT,
  //MENU_CORP_MYPAGE,
  MENU_CENTER,
  MENU_COMMUNITY,
];

const ADMIN_MENU_ITEMS = [
  MENU_DASHBOARD,
  MENU_ACCOUNT_MANAGEMENT,
  MENU_PRODUCT_MANAGEMENT,
  MENU_COHORT_MANAGEMENT,
  MENU_ADMIN_NETWORKING_MANAGEMENT,
  MENU_ADMIN_AgeTechService,
  MENU_CATEGORY_MANAGEMENT,
  MENU_COMMUNITY_MANAGEMENT,
  //MENU_CENTER,
];

const MANAGER_MENU_ITEMS = [
  MENU_DASHBOARD,
  MENU_MEMBER_MANAGEMENT,
  MENU_PRODUCT_MANAGEMENT,
  MENU_USER_COHORT,
  MENU_COMMUNITY_MANAGEMENT,
  // MENU_CATEGORY_MANAGEMENT,
  MENU_NETWORKING_MANAGEMENT,
  MENU_CENTER,
];

export const MENU_ITEMS = {
  COMMON_MENU_ITEMS,
  USER_MENU_ITEMS,
  CORP_MENU_ITEMS,
  ADMIN_MENU_ITEMS,
  COMMON_FOOTER_MENU_ITEMS,
  MANAGER_MENU_ITEMS,
};

export const USER_PROFILE_SUB_MENU = [
  { title: "프로필 정보", link: "/user" },
  { title: "나의 검색이력", link: "/user/searchHistory" },
  { title: "나의 매칭 현황", link: "/user/myMatching" },
];

export const CORP_PROFILE_SUB_MENU = [
  { title: "프로필 정보", link: "/corp" },
  { title: "나의 매칭 현황", link: "/corp/myMatching" },
];
